import React, {Component} from "react";
import {Link} from 'react-router-dom';
/*
    For Redux, importing connect and action
    Redux connect is to access Redux states
    Redux actions to update the Redux states
*/
import { connect } from "react-redux";
import { updateForm, setPage } from "../../../store/actions/FormAction";
/*
    Importing AlertDialogSlide for sliding Modal Window
*/
import AlertDialogSlide from "../../partials/AlertDialogSlide";
/*
    Importing LoanSlider that is a component that loanamt in Redux
*/
import ReloanSlider from "../../partials/ReloanSlider";
/*
    Importing ReloanButton that is a component that updates the page in Redux
*/
import ReloanButton from "../../partials/ReloanButton";
/*
    Custom styling of the range slider (Slider.css)
*/
import '../StartApplication/Slider.css';

/*
    Welcome view that displays the Welcome page
    Remember JSX requires you to use camelcasing of attributes
    (ie className vs 'class', htmlFor vs 'for', tabIndex vs tab-index)
    Remember JSX requires all tags be closed (ie: self closed <hr />, <br />)
    Create React App requires alt tags for all <img> elements (good for SEO too)
    SVGs need to have the xml attributes removed
*/
class Reloan extends Component {
  constructor(props){
    super(props);
    this.handleEConsentChange = this.handleEConsentChange.bind(this);
  }
  componentDidMount() {
    this.props.updateForm("pagename", "Loan Request");
    this.props.setPage("reloan");
    //For Testing Purposes
    if (this.props.st.length < 1){
      this.props.updateForm("fn", "John");
      this.props.updateForm("ln", "Doe");
      this.props.updateForm("address", "123 Main St, Columbus, OH, 34567");
      this.props.updateForm("street", "123 Main St");
      this.props.updateForm("city", "Columbus");
      this.props.updateForm("st", "Ohio");
      this.props.updateForm("stt", "OH");
      this.props.updateForm("zip", "34567");
      this.props.updateForm("eml", "jonathandoe@johndoeacct.com");
      this.props.updateForm("phn", "512-321-4567");
      this.props.updateForm("ismobile", true);
      this.props.updateForm("ssn", "XXX-XX-1234");
      this.props.updateForm("co", "ABCD Co");
      this.props.updateForm("cophn", "412-321-4567");
      this.props.updateForm("payfrequency", "Bi-Weekly");
      this.props.updateForm("payamount", "1643.56");
      this.props.updateForm("accounttype", "Checking");
      this.props.updateForm("bankaccount", "81214654564");
      this.props.updateForm("routingnum", "012100564");
      this.props.updateForm("sig1", "1234");
      this.props.updateForm("sig2", "1234");
      this.props.updateForm("sig3", "1234");
      this.props.updateForm("ref1fn", "Mary");
      this.props.updateForm("ref1ln", "Doe");
      this.props.updateForm("ref1phn", "512-321-4567");
      this.props.updateForm("ref1rel", "Sister");
      this.props.updateForm("ref2fn", "Jenny");
      this.props.updateForm("ref2ln", "Appleseed");
      this.props.updateForm("ref2phn", "312-555-4863");
      this.props.updateForm("ref2rel", "Cousin");
    }
  }

  handleEConsentChange(e) {
    let econsent = e.target.checked;
    this.props.updateForm("econsent", econsent);
    if (econsent){
      this.props.updateForm("consented", true);
    } else {
      this.props.updateForm("consented", false);
    }
  }

  render() {

      const nextLink = "/loandocs";
      const btnText = "Submit Request";

      return (
          <div id="dashboard2">
            <div className="dashheader">
              {this.props.pagename}
            </div>
            <div className="container" id="step-1">
                <div className="text-center topcopy">
                    <h1>Submit Your Loan Request</h1>
                    <p>Choose your loan amount, then review and sign your new loan agreements.<br/>
                    It&#39;s that easy.</p>
                </div>

                <hr />
                <form className="flowform">
                  <div id="loanslider" className="text-center form-group">
                      <p className="buttontitle ptop">How much do you want to borrow?</p>
                      <ReloanSlider />
                  </div>

                  <p className="buttontitle">Terms</p>
                  <div className="errortip hidden">
                      Please accept the terms.
                  </div>
                  <div className="checkbox checkbox-circle">
                      <input type="checkbox" id="econsent" name="econsent" className="styled" checked={this.props.econsent} onChange={this.handleEConsentChange} tabIndex="2" />
                      <label htmlFor="econsent">I confirm I have read and agree to the <AlertDialogSlide linkText="Electronic Communications Agreement" tip="econsent"/> and agree to receive electronic disclosures and transact business electronically.</label>
                  </div>

                  <ReloanButton next={nextLink} btnText={btnText} btnClasses="btn padtop first-step" disableNext={!this.props.consented} tabIndex="3" />

                  <p className="text-center padtop">
                    <Link to="myaccount">Back to my account</Link>
                  </p>
                </form>
            </div>
          </div>
        );
    }
}

const mapStateToProps = (state) => ({
    st: state.FormReducer.st,
    page: state.FormReducer.page,
    pagename: state.FormReducer.pagename,
    loanamt: state.FormReducer.loanamt,
    askedforamt: state.FormReducer.askedforamt,
    minamt: state.FormReducer.minamt,
    approvedamt: state.FormReducer.approvedamt,
    consented: state.FormReducer.consented,
    lateststep: state.FormReducer.lateststep,
    currentstep: state.FormReducer.currentstep
});

const mapDispatchToProps = (dispatch) => ({
    updateForm: (stateType, value) => dispatch(updateForm(stateType, value)),
    setPage: (page) => dispatch(setPage(page))
});

export default connect(mapStateToProps, mapDispatchToProps)(Reloan);



// WEBPACK FOOTER //
// ./src/components/views/Dashboard/Reloan.js